import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { LayerGroupIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/group-management')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="configurationManagement.groupsManagement.crumb" icon={LayerGroupIcon} />,
      title: <CrumbTitle id="configurationManagement.groupsManagement.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
